import { KnopClient } from "@opstel/query/knopClient";
import { createContext } from "react";

export interface KnopClientContextProps {
  knopClient: KnopClient;
}

export const KnopClientContext = createContext<KnopClientContextProps | undefined>(undefined);
